import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { IdtSharedRenderService } from 'render/render-shared/idt-shared-render.service';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { PieceMarqueeRenderComponent } from './piece-marquee-render.component';


export const pieceMarqueeRenderModuleEntryComponents = [
  PieceMarqueeRenderComponent
];
@NgModule({
  imports: [
    RenderSharedModule,
    RenderBlocksModule,
    SharedModule
  ],
  providers: [
    IdtSharedRenderService
  ],
  declarations: pieceMarqueeRenderModuleEntryComponents,
  exports: [PieceMarqueeRenderComponent]
})
export class PieceMarqueeRenderModule {}

export default pieceMarqueeRenderModuleEntryComponents;
